/** package_price_list 单项上的 option 标识（兼容 option_code / code） */
export const getPackagePriceListItemCode = (item) => item.option_code ?? item.code ?? '';
/**
 * 把「原 option 价格字段 + 套装包价列表」统一收敛成 UI 可直接消费的展示字段。
 *
 * 文案优先级：
 * - 先在 `packagePriceList` 中按 `optionCode` 命中：用命中项的 `package_price_desc` / `price` / `icon_list`
 * - 未命中：用 `optionPackagePriceDesc`（一般为 `option_map[code].package_price_desc`），避免返回空串覆盖 spread 前的 option
 * - 金额展示仍走返回的 `display_price`，由调用方与 `priceFilters` / 主价文案工具配合
 */
export const resolvePackagePriceDisplay = ({ optionCode, price, packagePriceList = [], optionPackagePriceDesc, }) => {
    const matchedPackagePrice = optionCode
        ? packagePriceList.find((item) => {
            const listCode = getPackagePriceListItemCode(item);
            return listCode === optionCode;
        })
        : undefined;
    const resolvedPackagePriceDesc = matchedPackagePrice?.package_price_desc || optionPackagePriceDesc || '';
    const pkgIcons = matchedPackagePrice?.icon_list;
    const iconListFromPackage = matchedPackagePrice &&
        Array.isArray(pkgIcons) &&
        pkgIcons.length > 0
        ? pkgIcons
        : undefined;
    return {
        package_price_desc: resolvedPackagePriceDesc,
        display_price: matchedPackagePrice?.price ?? price,
        has_package_price_desc: !!resolvedPackagePriceDesc,
        display_price_text: resolvedPackagePriceDesc || '',
        ...(iconListFromPackage ? { icon_list: iconListFromPackage } : {}),
    };
};
